import React, { useState } from 'react';
import {
  Container,
  Title,
  Text,
  Button,
  TextInput,
  PasswordInput,
  Group,
  Stack,
  Paper,
  Alert,
} from '@mantine/core';
import { LogIn, AlertTriangle } from 'lucide-react';

export default function Login({ onSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError('Username and password are required.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Invalid credentials');
      }
      const data = await response.json();
      onSuccess(data.runtimeSecret);
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container size="xs" py={80}>
      <Paper p="xl" radius="lg" withBorder>
        <Stack gap="lg">
          <Stack align="center" ta="center" gap="xs">
            <LogIn size={48} color="var(--mantine-color-blue-filled)" />
            <Title order={2}>Admin Login</Title>
            <Text c="dimmed">
              Enter your admin credentials to manage the server configuration.
            </Text>
          </Stack>

          {error && (
            <Alert
              variant="light"
              color="red"
              icon={<AlertTriangle size={16} />}
            >
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <Stack gap="md">
              <TextInput
                label="Username"
                placeholder="admin"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
              />
              <PasswordInput
                label="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <Button
                type="submit"
                loading={loading}
                fullWidth
                mt="md"
              >
                Login
              </Button>
            </Stack>
          </form>
        </Stack>
      </Paper>
    </Container>
  );
}
